import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import PostJob from "./post_job/PostJob";
import { auth, db, ref } from "../utilities/firebaseConfig";
import { get, onValue } from "firebase/database";
import ClickOutsideWrapper from "./ClickOutSideWrapper";
import MyAccount from "./my_account/MyAccount";
import { getAuth, signOut } from "firebase/auth";
import Pricing from "./pricing/Pricing";
import PlanAndBill from "./PlanandBill";
import NotificationBell from "./NotificationBell";

function DashboardLayout({ children }) {
  const [isModalOpen, setModalOpen] = useState(false);
  const [isPlan, setPlanOpen] = useState(false);
  const [isAccountOpen, setIsAccountOpen] = useState(false);
  const [isPricing, setIsPricing] = useState(false);
  const [showNotfModal, setShowNotfModal] = useState(false);
  const [showProfModal, setShowProfModal] = useState(false);
  const [activeJobs, setActiveJobs] = useState([]);
  const [userData, setUserData] = useState(null);
  const [selectedStatus, setSelectedStatus] = useState("all");
  const [showNav, setShowNav] = useState(false);
  const navigate = useNavigate();
  const user = auth.currentUser;

  useEffect(() => {
    const fetchActiveJobs = () => {
      const user = auth.currentUser;
      if (!user) {
        return;
      }

      // Reference to the "jobs" node in the database.
      const jobsRef = ref(db, "jobs");
      onValue(jobsRef, async (snapshot) => {
        if (snapshot.exists()) {
          // Convert jobs object to an array of job objects with their id.
          const jobsData = Object.entries(snapshot.val()).map(([id, job]) => ({
            id,
            ...job,
          }));

          // Filter for jobs that belong to the current user and have status "accepted".
          let filteredJobs = jobsData.filter((job) => job.userId === user.uid);

          filteredJobs = filteredJobs.filter(
            (job) => job.status !== "completed" && job.status !== "cancelled"
          );

          // For each filtered job, fetch the technician details (if technicianId exists).
          const jobsWithTechDetails = await Promise.all(
            filteredJobs.map(async (job) => {
              if (job.technicianId) {
                const techRef = ref(db, `technicians/${job.technicianId}`);
                const techSnapshot = await get(techRef);
                if (techSnapshot.exists()) {
                  return { ...job, technician: techSnapshot.val() };
                }
              }
              return job;
            })
          );

          setActiveJobs(jobsWithTechDetails);
        } else {
          setActiveJobs([]);
        }
      });
    };

    fetchActiveJobs();
  }, [navigate, user]);
  useEffect(() => {
    const currentUser = auth.currentUser;

    if (!currentUser) {
      console.warn("No user is currently signed in");
      return;
    }

    const userRef = ref(db, `users/${currentUser.uid}`);
    const unsubscribe = onValue(
      userRef,
      (snapshot) => {
        if (snapshot.exists()) {
          setUserData(snapshot.val());
        } else {
          console.log("User data not found");
        }
      },
      (error) => {
        console.error("Error fetching user data:", error);
      }
    );

    // Clean up listener on unmount
    return () => unsubscribe();
  }, []);

  const handleSignOut = async () => {
    const auth = getAuth();
    try {
      await signOut(auth);
      console.log("User signed out");
      navigate("/login"); // redirect to login page
    } catch (error) {
      console.error("Error signing out:", error);
    }
  };
  return (
    <>
      <PostJob isOpen={isModalOpen} onClose={() => setModalOpen(false)} />
      <MyAccount
        isOpen={isAccountOpen}
        onClose={() => setIsAccountOpen(false)}
      />
      <PlanAndBill isOpen={isPlan} onClose={() => setPlanOpen(false)} />
      <Pricing isOpen={isPricing} onClose={() => setIsPricing(false)} />
      <div className='dashboardlayout_cnt'>
        <div className='dashboardlayout_sidebar'>
          <Link to='/client/dashboard' className='dashlogo'>
            Profixexpress
          </Link>
          <div className='thespacee'></div>
          <div className='thespacee'></div>
          <div className='thespace'></div>
          <div className='dashtaskcenter'>
            <p className='dashtaskcenterp'>My tasks</p>
            <button
              className='dashaddtaskbtn'
              onClick={() => setModalOpen(true)}
            >
              <svg
                xmlns='http://www.w3.org/2000/svg'
                viewBox='0 0 24 24'
                width='18'
                height='18'
                fill='currentColor'
              >
                <path d='M11 11V5H13V11H19V13H13V19H11V13H5V11H11Z'></path>
              </svg>
            </button>
          </div>
          <div className='thespac'></div>
          <div className='dashdivider'></div>
          <div className='thespac'></div>
          {activeJobs.length > 0 ? (
            activeJobs.map((job) => (
              <div
                className='dashtas'
                key={job.id}
                onClick={() => navigate(`/client/job/${job.id}`)}
              >
                <p className='actjobtitle'>{job.jobtitle}</p>
                <p className='actjobprog'>{job.status}</p>
              </div>
            ))
          ) : (
            <p>You have no task yet.</p>
          )}

          <div className='thespacee'></div>
          <div className='thespacee'></div>
          <div className='dashtaskcenter'>
            <p className='dashtaskcenterp'>Quick Links</p>
          </div>
          <div className='thespac'></div>
          <div className='dashdivider'></div>
          <div className='thespac'></div>
          <div className='navbartheview'>
            <div className='thslas' onClick={() => setPlanOpen(true)}>
              Plan & Billing
            </div>
            <div className='thespace'></div>
            <Link className='thslas' to='/client/job-history'>
              Job History
            </Link>
            <div className='thespace'></div>
            <Link className='thslas' to='/client/support'>
              Support
            </Link>
          </div>
        </div>
        <div className='dashboardlayout_bodycnt'>
          <div className='dashboardlayout_bodytop'>
            <div className='dlbdyleft'>
              <button onClick={() => setShowNav(true)} className='haolsn'>
                <svg
                  xmlns='http://www.w3.org/2000/svg'
                  viewBox='0 0 24 24'
                  fill='#3d3d3d'
                  width={24}
                >
                  <path d='M13.1717 12.0007L8.22192 7.05093L9.63614 5.63672L16.0001 12.0007L9.63614 18.3646L8.22192 16.9504L13.1717 12.0007Z'></path>
                </svg>
              </button>
            </div>
            <div className='dlbdyright'>
              <button className='dlbdupg' onClick={() => setIsPricing(true)}>
                Upgrade
              </button>
              <div className='notificationcent'>
                <NotificationBell />
              </div>

              <div className='navproficnt'>
                <button
                  className='dldpro'
                  onClick={() => setShowProfModal(true)}
                >
                  {`${userData?.name?.[0] || ""}${
                    userData?.lastName?.[0] || ""
                  }`.toUpperCase()}
                </button>
                {showProfModal && (
                  <ClickOutsideWrapper
                    onClickOutside={() => setShowProfModal(false)}
                  >
                    <div className='navpfrcasn'>
                      <p className='navpname'>
                        {`${userData?.name?.[0] || ""}${
                          userData?.lastName?.[0] || ""
                        }`.toUpperCase()}
                      </p>
                      <div className='thegap'></div>
                      <h1 className='navpnamepar'>
                        {userData?.name} {userData?.lastName}
                      </h1>
                      <p className='navpnameparemail'>{userData?.email}</p>
                      <div className='thegap'></div>
                      <button
                        className='navpracnt'
                        onClick={() => {
                          setIsAccountOpen(true);
                          setShowProfModal(false);
                        }}
                      >
                        My Account
                      </button>
                      <div className='thespac'></div>
                      <div className='dividar'></div>
                      <div className='thespac'></div>
                      <div className='theproslink'>
                        <Link>Help & FAQ</Link>
                        <div className='thegap'></div>
                        <Link>Report a problem</Link>
                      </div>
                      <div className='thespac'></div>
                      <div className='dividar'></div>
                      <div className='thespac'></div>
                      <div className='theproslink'>
                        <button className='tepsabtn' onClick={handleSignOut}>
                          Log out
                        </button>
                      </div>
                    </div>
                  </ClickOutsideWrapper>
                )}
              </div>
            </div>
          </div>
          <div className='dashboardlayout_bodybottom'>{children}</div>
        </div>
      </div>
      {showNav && (
        <div className='navcover'>
          <div className='theslahs'>
            <Link to='/client/dashboard' className='iuaus'>
              ProfixExpress
            </Link>{" "}
            <button className='jkolan' onClick={() => setShowNav(false)}>
              <svg
                xmlns='http://www.w3.org/2000/svg'
                viewBox='0 0 24 24'
                width='24'
                height='24'
                fill='currentColor'
              >
                <path d='M10.5859 12L2.79297 4.20706L4.20718 2.79285L12.0001 10.5857L19.793 2.79285L21.2072 4.20706L13.4143 12L21.2072 19.7928L19.793 21.2071L12.0001 13.4142L4.20718 21.2071L2.79297 19.7928L10.5859 12Z'></path>
              </svg>
            </button>
          </div>
          <div className='thespace'></div>
          <div className='alksash'>
            <button className='dldpro'>
              {`${userData?.name?.[0] || ""}${
                userData?.lastName?.[0] || ""
              }`.toUpperCase()}
            </button>
            <p className='alkkssh'>{userData?.name}</p>
          </div>

          <div className='thespacee'></div>
          <div className='oieah'>
            <div
              className=''
              onClick={() => {
                setIsAccountOpen(true);
                setShowNav(false);
              }}
            >
              Account
            </div>
            <div
              className=''
              onClick={() => {
                setPlanOpen(true);
                setShowNav(false);
              }}
            >
              Plan & Billing
            </div>
            <Link to='/client/job-history' className=''>
              Job History
            </Link>
          </div>
          <div className='thespacee'></div>

          <div className='dividar'></div>
          <div className='thespacee'></div>
          <div className='iweya'>
            <Link to='/login' className=''>
              Support
            </Link>
            <Link to='/client/signup' className=''>
              Help & FAQ
            </Link>
            <Link to='/login' className=''>
              Report a problem
            </Link>
            <Link to='/client/login' className=''>
              Log out
            </Link>
          </div>
        </div>
      )}
    </>
  );
}

export default DashboardLayout;
